// Maps frontend routes to a menu permission key (must match backend menu_catalog.py).
export const PATH_KEY = {
  "/": "dashboard",
  "/sales/create": "cashier",
  "/sales": "sales_list",
  "/sales/shipping": "shipping_sale",
  "/sales/keep": "keep",
  "/sales/keep/create": "keep",
  "/sales/keep/edit": "keep",
  "/sales/preorder": "preorder",
  "/sales/preorder-batches": "preorder",
  "/sales/preorder-ready": "preorder",
  "/ventedaily/online-sales": "ventedaily",
  "/ventedaily/desty-shipped": "ventedaily",
  "/ventedaily/shipping": "ventedaily",
  "/ventedaily/withdrawal": "ventedaily",
  "/bazar": "bazar",
  "/marketing/kol": "marketing_kol",
  "/master/customer": "customer",
  "/master/discount": "discount",
  "/products": "product",
  "/inventory/labels": "product_label",
  "/products/variant-mapping": "variant_mapping",
  "/transfers": "transfer_stock",
  "/inventory/stock-in": "stock_in",
  "/inventory/stock-out": "stock_out",
  "/inventory/defect": "defect",
  "/inventory/forecast": "stock_prediction",
  "/inventory/opname": "opname",
  "/inventory/categories": "category",
  "/inventory/colors": "colour",
  "/inventory/sizes": "size",
  "/purchase-requests": "purchase_request",
  "/purchase-orders": "purchase_order",
  "/return/customer": "return_customer",
  "/return/supplier": "return_supplier",
  "/suppliers": "supplier",
  "/tailor": "tailor",
  "/product-list": "product_list",
  "/stock": "stock_warehouse",
  "/movements": "stock_movement",
  "/warehouses": "warehouse_rack",
  "/production/dashboard": "prod_overview",
  "/production/fabrics": "prod_material",
  "/production/accessories": "prod_material",
  "/production/material-purchases": "prod_material",
  "/production/plans": "prod_planning",
  "/production/bom": "prod_planning",
  "/production/products": "prod_planning",
  "/production/cutting": "prod_production",
  "/production/orders": "prod_production",
  "/production/receiving-hub": "prod_production",
  "/production/wip": "prod_production",
  "/production/fabric-returns": "prod_production",
  "/production/defects": "prod_production",
  "/finance/cost": "finance",
  "/finance/expense": "finance",
  "/finance/settlement": "finance",
  "/finance/rab": "rab",
  "/reports": "reports",
  "/production/reports": "production_report",
  "/users": "users",
  "/roles": "roles",
  "/user-activity": "user_activity",
  "/settings": "settings",
  "/printer": "printer",
  "/master/customer-group": "customer_group",
  "/master/payment-methods": "payment_type",
  "/pos-sync": "pos_integration",
  "/import-purchase": "pos_integration",
  "/import-history": "pos_integration",
  "/reconciliation": "pos_integration",
};

export function keyForPath(pathname) {
  if (PATH_KEY[pathname]) return PATH_KEY[pathname];
  let best = null, bl = -1;
  for (const p in PATH_KEY) {
    if (pathname === p || pathname.startsWith(p + "/")) {
      if (p.length > bl) { best = PATH_KEY[p]; bl = p.length; }
    }
  }
  return best;
}

const cap = (user, key, field) => {
  if (!user) return false;
  if (user.is_owner) return true;
  if (!key) return true; // unmapped routes are always allowed
  return !!(user.permissions && user.permissions[key] && user.permissions[key][field]);
};

export const canView = (user, key) => cap(user, key, "view");
export const canEdit = (user, key) => cap(user, key, "edit");
export const canDetail = (user, key) => cap(user, key, "detail");
export const canDelete = (user, key) => cap(user, key, "delete");

export function firstViewablePath(user) {
  if (!user) return "/";
  for (const path in PATH_KEY) {
    if (canView(user, PATH_KEY[path])) return path;
  }
  return null;
}
